let apiUrl = '';

export const getBaseUrl = () => apiUrl;

export const setDataProviderBaseUrl = (url: string) => (apiUrl = url);
